import React from 'react';
import './PricingCarousel.css';

const PricingCarousel = () => {
    // Array of logo data from the provided HTML
    const logos = [
        { src: 'https://sendbird.imgix.net/cms/lgo-match.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo match' },
        { src: 'https://sendbird.imgix.net/cms/lgo-virgin.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo virgin' },
        { src: 'https://sendbird.imgix.net/cms/lgo-redfin.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo redfin' },
        { src: 'https://sendbird.imgix.net/cms/lgo-carousell.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo carousell' },
        { src: 'https://sendbird.imgix.net/cms/lgo-hinge.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo hinge' },
        { src: 'https://sendbird.imgix.net/cms/lgo-yahoo.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo yahoo' },
        { src: 'https://sendbird.imgix.net/cms/lgo-noom.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo noom' },
        { src: 'https://sendbird.imgix.net/cms/lgo-accolade.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo accolade' },
        { src: 'https://sendbird.imgix.net/cms/lgo-lotte.svg?auto=format,compress&crop=faces&h=200', alt: 'Lgo lotte' },
    ];

    // Duplicate the logos to create a seamless, continuous loop effect
    const duplicatedLogos = [...logos, ...logos];

    return (
        <section className="lgr-carousels-section">
            <div className="container">
                <div className="lgr-carousels__head">
                    <h4 className="lgr-carousels__title">The world's most popular apps send with Sendbird</h4>
                </div>
                <div className="logo-garden-carousel">
                    <div className="swiper-wrapper">
                        {duplicatedLogos.map((logo, index) => (
                            <div className="lgrc-logo" key={index}>
                                <img src={logo.src} alt={logo.alt} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingCarousel;